import React from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@sweetgreen/garnish';

import { PaymentMethodListItem } from '@order/components';
import { useCustomer } from '@order/Customer';
import { useLocalizationContext } from '@order/Localization';

import { CREDIT_CARDS_ICONS } from '../../../constants';

export const PaymentMethodSelector = ({ onSelect }: Selector) => {
  const { customer } = useCustomer();
  const { t } = useLocalizationContext();
  const account =
    customer.billingAccounts?.find((ba) => ba.isDefault) ??
    customer.billingAccounts?.[0];

  return (
    <View style={styles.padding}>
      {account ? (
        <PaymentMethodListItem
          testID="scan-to-pay.payments.selector"
          accessibilityLabel={t('account.payment.title')}
          accessibilityHint={t('account.payment.title')}
          iconName={CREDIT_CARDS_ICONS[account.cardType]}
          title={account.nickname}
          subtitle={account.description}
          notice={
            account.expirationState === 'EXPIRED'
              ? t('account.payment.expired')
              : account.expirationState === 'NEARING'
              ? t('account.payment.expiring')
              : null
          }
          tag={account.isDefault ? t('account.payment.default') : null}
          onPress={onSelect}
        />
      ) : (
        <PaymentMethodListItem
          testID="account.edit-payment.new"
          accessibilityLabel={t('account.payment.title')}
          accessibilityHint={t('account.payment.title')}
          iconName={CREDIT_CARDS_ICONS.NEW}
          title={t('account.payment.new')}
          onPress={onSelect}
        />
      )}
    </View>
  );
};

type Selector = {
  readonly onSelect: () => void;
};

const styles = StyleSheet.create({
  padding: {
    paddingHorizontal: theme.spacing.small,
  },
});
